module.exports = __webpack_public_path__ + "static/media/sws.e53ce94e.png";